/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RedirectDataDto } from '../../models/redirect-data-dto';

export interface AuthRedirectSsoLogout$Params {
  'x-trace-id'?: string;
  post_logout_redirect_uri: string;
  id_token_hint: string;
}

export function authRedirectSsoLogout(http: HttpClient, rootUrl: string, params: AuthRedirectSsoLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<RedirectDataDto>> {
  const rb = new RequestBuilder(rootUrl, authRedirectSsoLogout.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.query('post_logout_redirect_uri', params.post_logout_redirect_uri, {});
    rb.query('id_token_hint', params.id_token_hint, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RedirectDataDto>;
    })
  );
}

authRedirectSsoLogout.PATH = '/api/auth/sso-logout';
